import * as React from 'react';
import * as IconsLibrary from './Library';

const CustomIcon = ({ icon, ...rest }) => {
    if (icon) {
        let Component = IconsLibrary[icon];

        if (Component && typeof Component !== 'undefined') {
            return <Component {...rest} />;
        }

        console.error('ERROR: SVG icon (' + icon + ') does not exist');
        return null;
    }

    console.error('ERROR: icon props is missing');
    return null;
};

export default CustomIcon;